import { createFileRoute } from "@tanstack/react-router";

import { LegalDocumentPage } from "~/components/legal/LegalDocumentPage";

export const Route = createFileRoute("/(public)/privacy")({
  component: () => <LegalDocumentPage type="privacy" title="Privacyverklaring" />,
});
